import ChatMessage from "../model/ChatMessage";

export default class ChatNpcMessageEvent {
    /**
     * @constructor
     * @param {string} type 
     * @param {ChatMessage} chatMessage 
     */
    constructor(type, chatMessage) {
        this.type = type;
        this.chatMessage = chatMessage;
    }
}

ChatNpcMessageEvent.SENT = "ChatNpcMessageEvent.SENT";